// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__81Ort","gfeWrapper":"CalendarEvent_gfeWrapper__3f6Zz"};